<template>
	<div v-if="data">
		<loading :active="loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<div class="row">
			<div class="col-md-10 col-md-push-2 p-r-10 p-l-0">
				<iframe
					class="embed-responsive-item"
					:src="link"
					:height="iframe.style.height"
					:width="iframe.style.width"
					@load="resizeIframe($event)" frameborder="0">
				</iframe>
			</div>
			<div class="col-md-2 col-md-pull-10 p-r-0">
				<div class="row">
					<div class="col-md-12">
						<template v-if="$platform">
							<div class="text-center p-t-20">
								<h3>
									<strong v-if="$platform.company">{{ $platform.company }}</strong>
									<strong v-else>{{ $platform.name }}</strong>
								</h3>
								<p>
									<template v-if="$platform.place">
										{{ $platform.place.formatted_address }}<br>
									</template>
									<template v-if="$platform.contact_email">
										{{ $platform.contact_email }}<br>
									</template>
									<template v-if="$platform.phone">
										{{ $platform.phone }}
										<template v-if="$platform.phone_2">
											- {{ $platform.phone_2 }}
										</template>
										<br>
									</template>
									<template v-else>
										<template v-if="$platform.phone_2">
											{{ $platform.phone_2 }}
										</template>
									</template>
									<template v-if="$platform.mobile">
										{{ $platform.mobile }}
										<template v-if="$platform.mobile_2">
											- {{ $platform.mobile_2 }}
										</template>
										<br>
									</template>
									<template v-else>
										<template v-if="$platform.mobile_2">
											{{ $platform.mobile_2 }}
										</template>
									</template>
								</p>
							</div>
							<hr>
						</template>
						<h2 class="text-center">
							<template v-if="user">
								<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/deliverynotes/' + data.id">
									<strong>Albarán {{$platform.setting.number_symbol}}{{ data.id }}</strong>
								</router-link>
							</template>
							<template v-else>
								<strong>Albarán {{$platform.setting.number_symbol}}{{ data.id }}</strong>
							</template>
						</h2>
						<div class="text-center">
							<template v-if="data.status">
								<button :class="'btn btn-' + data.status.class + ' btn-lg btn-rounded m-b-20 no-link'">
									<template v-if="data.status.lang">
										{{ data.status.lang.name }}
									</template>
									<template v-else>
										{{ data.status.name }}
									</template>
								</button>
							</template>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<h3 class="text-center">Firmar</h3>
					</div>
					<template v-if="data.signature">
						<img :src="data.signature" class="img-responsive">
					</template>
					<template v-else>
						<div class="col-md-12">
							<div class="white-box">
								<VueSignaturePad
									width="100%"
									height="200px"
									ref="signaturePad"/>
							</div>
						</div>
						<div v-if="$refs.signaturePad" class="col-md-12">
							<div class="row">
								<div class="col-md-6">
									<button @click="clear" type="button" class="btn btn-default btn-block">
										Limpiar
									</button>
								</div>
								<div v-if="!$refs.signaturePad.isEmpty()" class="col-md-6">
									<button @click="save" type="button" class="btn btn-default btn-block">
										Guardar
									</button>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				random: this.$route.params.random,
				data: null,
				link: null,

				loading: false,

				iframe: {
					style: {
						width: null,
						height: null,
					},
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				if(this.random) {
					this.loading = true
					this.$http.get('management/delivery/notes/' + this.random)
					.then(response => {
						this.data = response.body
						this.loadLink()
						this.loading = false
					}, function(error) {
						console.log(error)
						this.loading = false
					})
				}
			},
			loadLink() {
				this.link = this.$env.ROOT + '/' + this.$lang.getLang() + '/' + this.$platform.slug +'/pdf/viewer'
				if(this.data) {
					if(this.data.link) {
						this.link = this.link + '?file=' + this.data.link
					}
				}
			},
			resizeIframe() {
				this.iframe.style = {
					width: '100%',
					height: window.innerHeight,
				}
			},
			clear() {
				this.$refs.signaturePad.clearSignature()
			},
			save() {
				const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
				var request = {
					signature: data
				}
				this.sign(request)
			},
			sign(data) {
				this.loading = true
				this.$http.post('management/delivery/notes/' + this.data.id + '/sign', data)
				.then(response => {
					this.reload()
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/public/management/deliverynotes/views/DeliveryNoteViewer.vue